import gql from 'graphql-tag';

export const ImageAttachmentFragment = gql`
  fragment ImageAttachment on ImageAttachment {
    originalUrl
    previewUrl
    thumbnailUrl
  }
`;
